class Mobile {
    constructor() { }

    isMobile(maxWidth = 768) {
        return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
    }
}

export default new Mobile();
